import { Box, Switch, TextField, Typography } from "@mui/material";
import dayjs from "dayjs";
import { getYearRange, updateStateObjectData } from "../../../utility/Common";
import { GameCssStyles } from "../../GameManagement/GameCssStyles";
import { MetadataSelectField } from "./MetadataSelectField";
import MultiSelectDropdownWithImages from "./MultiSelectDropdownWithImages";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const CommonEntityMetadata = ({ editableEntityData, setEditableEntityData, artists, global_constant,
    showLanguage,
    showCountry,
    showIndustry,
    showYear,
    platform,
    showReleased,
    showDuration,
    showPlot,
    showLabel,
    showArtistType,
    showSuperStar,
    showMultiSelectDropdownWithImages
}) => {
    return (
        <>
            <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                {showLanguage && <MetadataSelectField
                    label="Language"
                    value={editableEntityData?.metadata?.language}
                    onChange={(value) => updateStateObjectData(editableEntityData, setEditableEntityData, "metadata.language", value)}
                    options={global_constant.language}
                />}
                {showCountry && <MetadataSelectField
                    label="Country"
                    value={editableEntityData?.metadata?.country}
                    onChange={(value) => updateStateObjectData(editableEntityData, setEditableEntityData, "metadata.country", value)}
                    options={global_constant.country}
                />}
                {showIndustry && (
                    <MetadataSelectField
                        label="Industry"
                        value={editableEntityData?.metadata?.industry}
                        onChange={(value) => updateStateObjectData(editableEntityData, setEditableEntityData, "metadata.industry", value)}
                        options={global_constant.industry}
                    />
                )}
                {showArtistType && (<MetadataSelectField
                    label="Artist Type"
                    value={editableEntityData?.metadata?.type}
                    onChange={(value) => updateStateObjectData(editableEntityData, setEditableEntityData, "metadata.type", value)}
                    options={global_constant?.ArtistType}
                />)}
            </Box>

            <Box sx={styles.containerStyleRowWithoutBorderNoColor_sx}>
                {showYear && <MetadataSelectField
                    label="Year"
                    value={editableEntityData?.metadata?.year || ''}
                    onChange={(value) => updateStateObjectData(editableEntityData, setEditableEntityData, "metadata.year", value)}
                    options={getYearRange(1900).map((year) => ({ _id: year, value: year, label: year }))}
                />}
                {showReleased && <DatePicker
                    label="Release Date"
                    maxDate={dayjs()}
                    value={editableEntityData?.metadata?.released ? dayjs(editableEntityData.metadata.released, "DDMMMYYYY") : null}
                    onChange={(v) =>
                        updateStateObjectData(editableEntityData, setEditableEntityData, "metadata.released", dayjs(v).format("DDMMMYYYY"))
                    }
                    slotProps={{ textField: { fullWidth: true } }}
                    sx={GameCssStyles.formSingleLineTextField_sx}
                />}
                {showDuration && <TextField
                    fullWidth
                    label="Duration (minutes)"
                    type="number"
                    value={editableEntityData?.metadata?.duration || 0}
                    onChange={(e) =>
                        updateStateObjectData(editableEntityData, setEditableEntityData, `metadata.duration`, parseInt(e.target.value))
                    }
                    sx={GameCssStyles.formSingleLineTextField_sx}
                />}
            </Box>

            {platform && (
                <TextField
                    fullWidth
                    label="Platform"
                    rows={1}
                    value={editableEntityData?.metadata?.platform || ''}
                    onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, "metadata.platform", e.target.value)}
                    sx={GameCssStyles.formMultiLineTextField_sx}
                />
            )}

            {showLabel && (
                <TextField
                    fullWidth
                    label="Label"
                    rows={1}
                    value={editableEntityData?.metadata?.label || ''}
                    onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, "metadata.label", e.target.value)}
                    sx={GameCssStyles.formMultiLineTextField_sx}
                />
            )}

            {showPlot && (
                <TextField
                    fullWidth
                    label="Plot"
                    multiline
                    rows={10}
                    value={editableEntityData?.metadata?.plot || ''}
                    onChange={(e) => updateStateObjectData(editableEntityData, setEditableEntityData, "metadata.plot", e.target.value)}
                    sx={GameCssStyles.formMultiLineTextField_sx}
                />
            )}

            {showSuperStar && (
                <Box flex={1} display="flex" justifyContent="flex-end" alignItems="center">
                    <Typography mr={1}>is He/She Superstar ?</Typography>
                    <Switch
                        checked={editableEntityData?.metadata?.isSuperStar}
                        onChange={(e) =>
                            updateStateObjectData(editableEntityData, setEditableEntityData, 'metadata.isSuperStar', e.target.checked)
                        }
                        sx={GameCssStyles.switchStyle_sx}
                    />
                </Box>
            )}

            {showMultiSelectDropdownWithImages && (
                <MultiSelectDropdownWithImages
                    value={
                        Array.isArray(editableEntityData?.metadata?.artists)
                            ? editableEntityData.metadata.artists
                                .map(id => artists?.find(artist => artist?._id === id))
                                .filter(Boolean)
                            : []
                    }
                    artists={Array.isArray(artists) ? artists : []}
                    onChange={(event, newValue) => {
                        const selectedIds = Array.isArray(newValue)
                            ? newValue.map(artist => artist?._id)
                            : [];
                        updateStateObjectData(
                            editableEntityData,
                            setEditableEntityData,
                            'metadata.artists',
                            selectedIds
                        );
                    }} />
            )}
        </>
    );
}

const styles = {
    containerStyleRow_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        borderRadius: 1,
        border: '1px solid #000000',
        padding: 2,
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
        m: 4
    },
    containerStyleColumn_sx: {
        backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: 2,
    },
    containerStyleRowWithoutBorderNoColor_sx: {
        //backgroundColor: '#f4f1f9',
        justifyContent: 'center',
        display: "flex",
        flex: 1,
        flexDirection: "row",
        gap: 2
    },
}

export default CommonEntityMetadata;